import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';
import { useTarifariosEmpresasMantenedor } from '../../hooks/useTarifariosEmpresasMantenedor';
import TarifariosEmpresasTable from '../../components/Tarifarios/TarifariosEmpresasTable';
import TarifariosEmpresasFiltersButton from '../../components/Tarifarios/TarifariosEmpresasFiltersButton';
import TarifariosEmpresasFilters from '../../components/Tarifarios/TarifariosEmpresasFilters';

const TarifarioEmpresas = () => {
    const user = useSelector(state => state.auth.user);
    const { userPermissions } = useMantenedores();
    const permisos = userPermissions?.modules?.tarifarios || {};

    // Estado para el modal de filtros
    const [showFiltersModal, setShowFiltersModal] = useState(false);

    const {
        preciosEmpresas,
        total,
        loading,
        error,
        pageSize,
        pageNumber,
        servicioId,
        empresaId,
        regionId,
        comunaId,
        appliedFilters,
        handlePageChange,
        handlePageSizeChange,
        handleServicioChange,
        handleEmpresaChange,
        handleRegionChange,
        handleComunaChange,
        applyFilters,
        clearFilters,
        empresas,
        loadingEmpresas,
        servicios,
        regiones,
        comunas,
        updating,
        updateError,
        updatePreciosMasivo,
        clearUpdateError,
        refreshData
    } = useTarifariosEmpresasMantenedor(user, permisos);

    // Contar filtros activos (usar los filtros aplicados, no los temporales)
    const getActiveFiltersCount = () => {
        let count = 0;
        if (appliedFilters.servicioId) count++;
        if (appliedFilters.empresaId) count++;
        if (appliedFilters.regionId) count++;
        if (appliedFilters.comunaId) count++;
        return count;
    };

    const handleOpenFilters = () => {
        setShowFiltersModal(true);
    };

    const handleCloseFilters = () => {
        setShowFiltersModal(false);
    };

    const handleApplyFilters = (filters) => {
        // Usar la función applyFilters del hook
        applyFilters(filters);
        setShowFiltersModal(false);
    };

    const handleClearFilters = () => {
        clearFilters();
        setShowFiltersModal(false);
    };

    // Handler para cambios de región desde el modal
    const handleModalRegionChange = (regionId) => {
        handleRegionChange(regionId);
    };

    // Handler para cuando se actualiza un precio
    const handlePrecioUpdated = () => {
        console.log('Precio actualizado, refrescando datos...');
        // Refrescar los datos para mostrar los cambios
        setTimeout(() => {
            refreshData();
        }, 500); // Pequeño delay para asegurar que la actualización se completó en el servidor
    };

    return (
        <SimpleMantenedorLayout
            mantenedorId="tarifarios"
            title="Tarifario Empresas"
            subtitle="Gestión de precios específicos por empresa y comuna"
            iconColor="#28a745"
            showBackButton={false}
            backButtonPath="/mantenedores/tarifarios"
            breadcrumbs={[
                {
                    label: 'Tarifarios',
                    path: '/mantenedores/tarifarios'
                },
                {
                    label: 'Tarifario Empresas'
                }
            ]}
        >
            {error && <div className="alert alert-danger mb-2">{error}</div>}
            {updateError && <div className="alert alert-danger mb-2">{updateError}</div>}
            
            <TarifariosEmpresasTable
                data={preciosEmpresas}
                loading={loading}
                total={total}
                pageSize={pageSize}
                pageNumber={pageNumber}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                permisos={permisos}
                updating={updating}
                onPrecioUpdated={handlePrecioUpdated}
                updatePreciosMasivo={updatePreciosMasivo}
                clearUpdateError={clearUpdateError}
            >
                <TarifariosEmpresasFiltersButton 
                    onOpenFilters={handleOpenFilters}
                    activeFiltersCount={getActiveFiltersCount()}
                />
            </TarifariosEmpresasTable>

            <TarifariosEmpresasFilters
                show={showFiltersModal}
                onHide={handleCloseFilters}
                onFiltersChange={handleApplyFilters}
                onClearFilters={handleClearFilters}
                initialFilters={{
                    servicioId,
                    empresaId,
                    regionId,
                    comunaId
                }}
                servicios={servicios}
                empresas={empresas}
                regiones={regiones}
                comunas={comunas}
                loadingEmpresas={loadingEmpresas}
                onRegionChange={handleModalRegionChange}
            />
        </SimpleMantenedorLayout>
    );
};

export default TarifarioEmpresas;
